import { Form } from "antd";
import styled from "styled-components";

// Read-mode field: label and value merged into one bordered box,
// with the label as a small caption inside.
export const FormIteam = styled(Form.Item)`
  &.ant-form-item {
    border: 1px solid #d9d9d9;
    background: white;
    border-radius: 6px;
    padding: 3px 11px 5px;

    .ant-form-item-label {
      display: block;
      min-height: 0;
      padding: 0;
      text-align: left;
    }
    .ant-form-item-label > label {
      font-size: 11px;
      font-weight: 500;
      color: #6b6b66;
      height: auto;
      -webkit-line-clamp: 1;
    }
    .ant-form-item-control {
      border: none;
      background: transparent;
      padding: 0;
    }
  }
`;
